import { storeUserGeoLocation } from '@/helpers/geo-location-helper';
import { hasUCConsentBanner } from '@/helpers/tracking';
import { UsercentricsHelper } from '@/helpers/usercentrics-helper';
import { getUserCentricsConsentProfile } from '@/constants/user-centrics';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useUserStore } from '@/stores/pinia/useUserStore';

export default defineNuxtPlugin({
	parallel: true,
	async setup() {
		await storeUserGeoLocation();

		if (hasUCConsentBanner(useLanguageStore().webLocale)) {
			// This registers the window event listener and needs to run very early to catch events
			UsercentricsHelper.registerAndTrackUsercentricEvents(useUserStore().saveDPSConsents);
			UsercentricsHelper.preload(getUserCentricsConsentProfile()).catch(() => {});
		}

		import('@/helpers/bundle-size-monitor').then(({ initBundleSizeMonitor }) => initBundleSizeMonitor());
	},
});
